import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"
import { labTestDescriptionSkeleton } from "@widgets/v2/LabTestDescription/LabTestDescription.skeleton"
import { PreparationWidgetSkeleton } from "@widgets/v2/PreparationWidget/PreparationWidget.skeleton"
import { generalDescriptionSkeleton } from "@widgets/v2/GeneralDescription/GeneralDescription.skeleton"
import { testListsSkeleton } from "@widgets/v2/TestLists/TestLists.skeleton"
import { HorizontalPackageListing } from "@widgets/vsat/HorizontalPackageListing/HorizontalPackageListing.skeleton"
import { ListOfQuestionAnswers } from "@widgets/v2/ListOfQuestionAnswers/ListOfQuestionAnswers.skeleton"
import { ContentEditorialCredits } from "@widgets/v2/ContentEditorialCredits/ContentEditorialCredits.skeleton"
import { UpFrontMultiAttributeComparisonNew } from "@widgets/v2/UpFrontMultiAttributeComparisonNew/UpFrontMultiAttributeComparisonNew.skeleton"
import { ProcessCarousel } from "@widgets/vsat/ProcessCarousel/ProcessCarousel.skeleton"
import { Bibliography } from "@widgets/v2/Bibliography/Bibliography.skeleton"
import { AppDownloadNudge } from "@widgets/v2/AppDownloadNudge/AppDownloadNudge.skeleton"
import { CollapsibleTestInformation } from "@widgets/v2/CollapsibleTestInformation/CollapsibleTestInformation.skeleton"
import { PDPBestOfferSkeleton } from "@widgets/v2/PDPBestOffer/PDPBestOffer.skeleton"
import { LabEducationConfig } from "@widgets/v2/LabEducation/LabEducation.skeleton"

import css from "./TestPDPPage.scss"

const TestPDPPageSkeleton = () => {
    return (
        <div className="page-container">
            <div className="container-fluid flex padding-8-0">
                <div className={css.searchContainer}>
                    <div className="flex alignCenter gap-10 pY-8 pLeft-24 pRight-8">
                        <div className="flex alignCenter gap-8 mR-16">
                            <div
                                style={{
                                    width: "18.2px",
                                    height: "21px",
                                    backgroundColor: "#e9ecef",
                                    borderRadius: "4px",
                                }}
                            ></div>
                            <div
                                style={{
                                    width: "80px",
                                    height: "16px",
                                    backgroundColor: "#e9ecef",
                                    borderRadius: "4px",
                                }}
                            ></div>
                            <div
                                style={{
                                    width: "24px",
                                    height: "24px",
                                    backgroundColor: "#e9ecef",
                                    borderRadius: "4px",
                                }}
                            ></div>
                        </div>
                        <div className="middleDivider"></div>
                        <div className="flex1">
                            <div
                                style={{
                                    width: "100%",
                                    height: "40px",
                                    backgroundColor: "#e9ecef",
                                    borderRadius: "8px",
                                }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid flexColumn padding-8-0">
                <div className="widget-container marginBoth-8">
                    <div className="flex justifyBetween">
                        {/* Left column - col-15 widgets */}
                        <div>
                            <Skeleton config={labTestDescriptionSkeleton} isComponent />
                            <Skeleton config={PreparationWidgetSkeleton} isComponent />
                            <Skeleton config={generalDescriptionSkeleton} isComponent />
                            <Skeleton config={testListsSkeleton} isComponent />
                            <Skeleton config={HorizontalPackageListing} isComponent />
                            <Skeleton config={ListOfQuestionAnswers} isComponent />
                            <Skeleton config={ContentEditorialCredits} isComponent />
                            <Skeleton config={UpFrontMultiAttributeComparisonNew} isComponent />
                            <Skeleton config={ProcessCarousel} isComponent />
                            <Skeleton config={Bibliography} isComponent />
                            <Skeleton config={AppDownloadNudge} isComponent />
                            <Skeleton config={CollapsibleTestInformation} isComponent />
                        </div>

                        {/* Right column - col-8 widgets */}
                        <div className={css.stickyRightColumn}>
                            <Skeleton config={PDPBestOfferSkeleton} isComponent />
                            <Skeleton config={LabEducationConfig} isComponent />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TestPDPPageSkeleton
